export default "//cloud.imgsmail.ru/cloud.mail.ru/183089/img/build/empty-state/select_from_cloud.png";